// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ca186036","239":"8cbbbb6b","667":"8d1e0c56","762":"716fab7f"}[chunkId] + ".chunk.js";
};